module.exports = __webpack_public_path__ + "static/media/settings.5780de22.svg";